var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: _vm.$bem(),
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.item)
        },
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "row", class: _vm.$bem("wrapper") }, [
          _c(
            "div",
            {
              class: [
                _vm.canBeMarkedAsFavorite
                  ? _vm.$responsive.isMobile
                    ? "col-10"
                    : "col-8"
                  : "col-12",
              ],
            },
            [
              _c("div", { class: _vm.$bem("name") }, [
                _vm.item.keywords.storeLocation
                  ? _c("span", [
                      _vm._v(
                        "\n                  EDEKA Foodservice " +
                          _vm._s(_vm.item.city) +
                          " *\n                "
                      ),
                    ])
                  : _c("span", [_vm._v(_vm._s(_vm.item.name))]),
              ]),
              _vm._v(" "),
              _vm.showAddress
                ? _c("div", { class: _vm.$bem("street-and-number") }, [
                    _vm._v(
                      _vm._s(_vm.item.streetAndNumber) +
                        ", " +
                        _vm._s(_vm.item.zip) +
                        " " +
                        _vm._s(_vm.item.city)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.distance && _vm.showDistance
                ? _c("div", { class: _vm.$bem("distance") }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("distance")(_vm.item.distance)) +
                        " von Ihrem Standort entfernt\n              "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.canBeMarkedAsFavorite
            ? _c(
                "div",
                { class: _vm.$responsive.isMobile ? "col-2" : "col-4" },
                [
                  _c(
                    "div",
                    {
                      class: _vm.$bem("favorite"),
                      on: {
                        click: [
                          function ($event) {
                            return _vm.toggleFavorite(
                              $event,
                              _vm.item.identifier
                            )
                          },
                          function ($event) {
                            $event.stopPropagation()
                          },
                        ],
                      },
                    },
                    [
                      _c("favorite", {
                        attrs: {
                          city: _vm.item.city,
                          identifier: _vm.item.identifier,
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12", class: _vm.$bem("opening-hours-buttons") },
            [
              (_vm.openingHours || _vm.specialOpeningHours) &&
              _vm.showOpeningHours
                ? _c("div", { class: _vm.$bem("opening-hours") }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          "data-name": "Layer 1",
                          height: "24",
                          viewBox: "0 0 24 24",
                          width: "24",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8Zm1-8.251V7a1 1 0 0 0-2 0v5a1.006 1.006 0 0 0 .118.472l1.5 2.799a1 1 0 0 0 1.764-.944Z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { class: _vm.$bem("status") }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm._f("openingStatus")(_vm.item)) +
                          "\n                  "
                      ),
                      !_vm.item.temporaryClosed
                        ? _c("span", { class: _vm.$bem("hours") }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm._f("openingHours")(_vm.item)) +
                                "\n                  "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.website && _vm.showDetailsButton
                ? _c("div", { class: _vm.$bem("buttons") }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn--scnd",
                        attrs: { href: _vm.offerLink },
                      },
                      [_vm._v("Angebote")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn--prim",
                        attrs: { href: _vm.item.website },
                      },
                      [_vm._v("Details")]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }